import { GREEN_600, AMBER_400, MEDIUM_GRAY, CRIMSON_500 } from '../../styles/colors'

export type Status =
  | 'COMPLETED'
  | 'PENDING'
  | 'INITIATED'
  | 'CREATED'
  | 'UNDER_REVIEW'
  | 'PROCESSING'
  | 'PROCESSING_REFUND'
  | 'PROCESSING_DISBURSEMENT'
  | 'IN_PROGRESS'
  | 'WAITING_FOR_CONFIRMATION'
  | 'WAITING_FOR_DISBURSEMENT'
  | 'DENIED'
  | 'FAILED'
  | 'REJECTED'

type Props = {
  status: Status
}

const TransactionDetailStatusIcon = ({ status }: Props) => {
  switch (status) {
    case 'COMPLETED':
      return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.75 9L8.25 10.5L11.25 7.5M15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9Z" stroke="#096F45" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    case 'PENDING':
    case 'INITIATED':
    case 'CREATED':
      return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 6V9L11.25 11.25M15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9Z" stroke="#F2AF01" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    case 'UNDER_REVIEW':
    case 'PROCESSING':
    case 'PROCESSING_REFUND':
    case 'PROCESSING_DISBURSEMENT':
    case 'IN_PROGRESS':
    case 'WAITING_FOR_CONFIRMATION':
    case 'WAITING_FOR_DISBURSEMENT':
      return (
        <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="1" y="1" width="10.6667" height="14" rx="2" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <line x1="4" y1="7.66699" x2="6" y2="7.66699" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <line x1="4" y1="10.667" x2="8.66667" y2="10.667" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    case 'DENIED':
    case 'FAILED':
    case 'REJECTED':
      return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.5 13.5L13.5 4.5M4.5 4.5L13.5 13.5" stroke="#E7282D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    default:
      return <></>
  }
}

export const TRANSACTION_STATUS_COLOR = Object.freeze({
  COMPLETED: GREEN_600,
  PENDING: AMBER_400,
  CREATED: AMBER_400,
  INITIATED: AMBER_400,
  UNDER_REVIEW: MEDIUM_GRAY,
  PROCESSING: MEDIUM_GRAY,
  PROCESSING_REFUND: MEDIUM_GRAY,
  IN_PROGRESS: MEDIUM_GRAY,
  WAITING_FOR_CONFIRMATION: MEDIUM_GRAY,
  WAITING_FOR_DISBURSEMENT: MEDIUM_GRAY,
  PROCESSING_DISBURSEMENT: MEDIUM_GRAY,
  DENIED: CRIMSON_500,
  FAILED: CRIMSON_500,
  REJECTED: CRIMSON_500
})

export default TransactionDetailStatusIcon
